import Vue from 'vue'

import formatClid from './format_clid'
import { formatPercentage } from './format_number'
import formatTime from './format_time'
import formatPhoneNum from './phone_num'
import { formatDateLong, formatDateISO, formatDateReduced } from './format_date'

Vue.filter('formatClid', formatClid)
Vue.filter('formatPercentage', formatPercentage)
Vue.filter('formatTime', formatTime)
Vue.filter('formatPhoneNum', formatPhoneNum)
Vue.filter('formatDateLong', formatDateLong)
Vue.filter('formatDateISO', formatDateISO)
Vue.filter('formatDateReduced', formatDateReduced)
